import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddAttendanceLogEntryParameters, addAttendanceLogEntry } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import AttendanceLogEntry from 'src/models/AttendanceLogEntry';

export default function useAddAttendanceLogEntry() {
  const queryClient = useQueryClient();

  return useMutation<AttendanceLogEntry, ApiError, AddAttendanceLogEntryParameters>(async parameters => {
    const result = await addAttendanceLogEntry(parameters);
    queryClient.invalidateQueries(['attendanceLog']);
    return result;
  });
}
